export const SET_EMPLOYEES_LIST = 'EMPLOYEES_LIST/SET_EMPLOYEES_LIST';
export const SET_IS_EDIT_BUTTON_CLICKED = 'EMPLOYEES_LIST/SET_IS_EDIT_BUTTON_CLICKED';
export const SET_EMPLOYEE_REGISTER = 'EMPLOYEES_LIST/SET_EMPLOYEE_REGISTER';
export const HANDLE_LOADING = 'EMPLOYEES_LIST/HANDLE_LOADING';